(() => {
  if (window.ABLThemeComponents) return;
  const configNode = document.getElementById('abl-theme-components-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const pending = new Map();
  const modules = new Map();
  const components = config.components.map((component) => ({ ...component, loaded: false }));
  const importModule = (url) => {
    if (!modules.has(url)) {
      modules.set(url, import(url).catch((error) => {
        modules.delete(url);
        throw error;
      }));
    }
    return modules.get(url);
  };
  const load = (component) => {
    if (component.loaded || pending.has(component)) return;
    const dependencies = component.before || [];
    const result = dependencies.length
      ? Promise.all(dependencies.map(importModule)).then(() => importModule(component.url))
      : importModule(component.url);
    pending.set(component, result);
    result.then(() => { component.loaded = true; }).catch(() => {}).finally(() => pending.delete(component));
  };
  const scan = (scope = document) => {
    if (!scope?.querySelector) return;
    components.forEach((component) => {
      if (component.loaded || pending.has(component)) return;
      if (scope.matches?.(component.selector) || scope.querySelector(component.selector)) load(component);
    });
  };
  const start = () => {
    scan();
    const observer = new MutationObserver((records) => {
      const roots = new Set();
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.isConnected) roots.add(node);
      }));
      roots.forEach((root) => {
        let ancestor = root.parentElement;
        while (ancestor) {
          if (roots.has(ancestor)) return;
          ancestor = ancestor.parentElement;
        }
        scan(root);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    document.addEventListener('shopify:section:reorder', (event) => scan(event.target));
    window.ABLThemeComponents = { scan };
  };
  if (!('popover' in HTMLElement.prototype)) importModule(config.popover).then(start, start);
  else start();
})();
